const requestPandaPayPayment = data => {
    return new Promise(function(resolve, reject) {
        /*eslint no-undef:*/
        Panda.on('success', function(nonce) {
            resolve({ ...data, nonce });
        });

        Panda.on('error', function() {
            reject();
        });
        document.getElementById('panda_cc_form').dispatchEvent(new Event('submit'));
    });
};

export default requestPandaPayPayment;



// WEBPACK FOOTER //
// ./src/utils/donation/pandaPay.js